
document.addEventListener('DOMContentLoaded', function() {
    const shareButtons = document.querySelectorAll('.share-block__trigger');

    shareButtons.forEach(button => {
        button.addEventListener('click', function() {
            const wrapper = this.closest('.share-block__button-wrapper');
            const popup = wrapper.querySelector('.share-block__popup');

            if (window.innerWidth < 1024) {
                // Mobile: Move popup to overlay
                let overlay = document.querySelector('.share-block__overlay');
                if (!overlay) {
                    overlay = document.createElement('div');
                    overlay.className = 'share-block__overlay';
                    document.body.appendChild(overlay);
                }

                // Store original wrapper reference on popup
                popup.dataset.originalWrapper = wrapper.getAttribute('data-wrapper-id') ||
                    (wrapper.setAttribute('data-wrapper-id', Date.now()), wrapper.getAttribute('data-wrapper-id'));

                // Move popup to overlay
                overlay.appendChild(popup);
                overlay.classList.add('active');
                popup.style.display = 'block';

                // Prevent body scroll
                document.body.style.overflow = 'hidden';
            } else {
                // Desktop: Show popup in place
                popup.style.display = 'block';
            }
        });
    });

    // Close popup handlers
    document.addEventListener('click', function(e) {
        if (e.target.matches('.share-block__close') || e.target.matches('.share-block__overlay')) {
            const overlay = document.querySelector('.share-block__overlay');
            const popup = document.querySelector('.share-block__popup[style*="block"]');

            if (popup) {
                popup.style.display = 'none';

                if (overlay && overlay.classList.contains('active')) {
                    // Find original wrapper using stored reference
                    const wrapperId = popup.dataset.originalWrapper;
                    const wrapper = document.querySelector(`[data-wrapper-id="${wrapperId}"]`);

                    if (wrapper) {
                        wrapper.appendChild(popup);
                    }

                    overlay.classList.remove('active');
                    document.body.style.overflow = '';
                }
            }
        }

        // Desktop: Close when clicking outside popup
        if (window.innerWidth >= 1024) {
            const popup = e.target.closest('.share-block__popup');
            const trigger = e.target.closest('.share-block__trigger');

            if (!popup && !trigger) {
                const openPopup = document.querySelector('.share-block__popup[style*="block"]');
                if (openPopup) {
                    openPopup.style.display = 'none';
                }
            }
        }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
        const popup = document.querySelector('.share-block__popup[style*="block"]');
        const overlay = document.querySelector('.share-block__overlay.active');

        if (popup && overlay && window.innerWidth >= 1024) {
            // Find original wrapper using stored reference
            const wrapperId = popup.dataset.originalWrapper;
            const wrapper = document.querySelector(`[data-wrapper-id="${wrapperId}"]`);

            if (wrapper) {
                wrapper.appendChild(popup);
                overlay.classList.remove('active');
                document.body.style.overflow = '';
            }
        }
    });
});
